import BigNumber from 'bignumber.js';
import { curry } from 'ramda';

import { formatNumberWithPrefix } from './format-number';

const THRESHOLD = 1_000;

/**
 * @param value Input value
 * @param prefix Value prefix, ex. $
 */
export const formatCompactNumberWithPrefix = curry((prefix: string, value: number | string | null | undefined) => {
  if (value === null || value === undefined || value === '') {
    return 'N/A';
  }

  const valueBn = new BigNumber(value);
  const isNegative = valueBn.isNegative();
  const absoluteValue = valueBn.abs();

  if (absoluteValue.gte(THRESHOLD)) {
    const formatter = new Intl.NumberFormat('en-US', {
      notation: 'compact',
      maximumFractionDigits: 2,
      compactDisplay: 'short',
    });

    return isNegative
      ? `-${prefix}${formatter.format(absoluteValue.toNumber())}`
      : `${prefix}${formatter.format(absoluteValue.toNumber())}`;
  }

  return formatNumberWithPrefix(prefix)(value);
});

/**
 * @param value Input value
 */
export const formatCompactNumber = formatCompactNumberWithPrefix('');
